import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

import { unsetUser } from '@/app/slices/appSlice'
import { unsetContactId } from '@/app/slices/contactsSlice'
import { unsetCustomerId } from '@/app/slices/customerSlice'
import { unsetGuestUser } from '@/app/slices/guestUserSlice'
import AppToolbar from '@/common/components/AppBar/AppToolbar'

const Logout = () => {
    const dispatch = useDispatch()
    const { logout } = useKindeAuth()

    const handleLogout = async () => {
        await logout()
        dispatch(unsetCustomerId())
        dispatch(unsetContactId())
        dispatch(unsetUser())
        dispatch(unsetGuestUser())
    }

    useEffect(() => {
        handleLogout()
    }, [])

    return <AppToolbar />
}

export default Logout
